import React from "react";
import { navigate } from "gatsby";

const isBrowser = () => typeof window !== "undefined";

export const isLoggedIn = () => {
  const user = getUser();
  const userName= getDisplayName();
  const email = getEmail();
  return {exist:!!user.access_token, displayName:userName, email};
};

export const getUser = () =>
  isBrowser() && window.localStorage.getItem("google:tokens")
    ? JSON.parse(window.localStorage.getItem("google:tokens"))
    : {};

export const getDisplayName = () =>
  isBrowser() && window.localStorage.getItem("google:displayName")
    ? window.localStorage.getItem("google:displayName")
    : "";
export const getEmail = () =>
    isBrowser() && window.localStorage.getItem("google:email")
      ? window.localStorage.getItem("google:email")
      : "";

const PrivateRoute = ({ component: Component, location, ...rest }) => {
  if (!isLoggedIn() && location.pathname !== `/`) {
    navigate("/");
    return null;
  }
  return <Component {...rest} />;
};
export default PrivateRoute;
